/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import { cornerRadiusTokensV2CssVars } from '@uber/base-specs';

/**
 * Base 2.0 corner radius ramp, exposed on `theme.cornerRadius`.
 *
 * Consumed directly from `@uber/base-specs` (`cornerRadiusTokensV2CssVars`),
 * which owns the camelCase key naming (`radius6` … `radiusFull`) — the corner
 * radius analogue of `elevationTokensV2CssVars`. baseui no longer remaps the
 * hyphenated SOT keys itself, keeping base-specs the single source of truth.
 *
 * Each value is a `var(--base-corner-radius-*)` reference. Corner radius has no
 * light/dark modes, and the underlying custom properties are emitted at `:root`
 * (see base-corner-radius-v2.css), so these resolve without any data attribute
 * or JS theme swap — e.g. `css({ borderRadius: theme.cornerRadius.radius12 })`.
 *
 * `radiusFull` resolves to 1000px — the Figma source uses this large value to
 * fake full roundness; it is preserved verbatim as the source-of-truth value.
 */
const cornerRadiusTokens = cornerRadiusTokensV2CssVars;
export type CornerRadius = Record<keyof typeof cornerRadiusTokens, string>;
export { cornerRadiusTokens as default };